module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeSpoon@3x.e028429b.png";